import { Component, Renderer2, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { finalize } from 'rxjs';
import { BarcodeFormat } from '@zxing/library';
import { FunctionsService } from 'src/app/data/functions.service';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-fullscreen-modal',
  templateUrl: './fullscreen-modal.component.html',
  styleUrls: ['./fullscreen-modal.component.css']
})
export class FullscreenModalComponent {
  constructor(
    public dialogRef: MatDialogRef<FullscreenModalComponent>,
    private functions: FunctionsService,
    private router: Router,
    private renderer: Renderer2,
  ) { }

  private orientationMediaQuery!: MediaQueryList;
  private orientationListener!: () => void;
  @ViewChild('scanner') scanner: ZXingScannerComponent;
  scanResult: string;
  product: any;
  isPortrait: boolean = false;
  allowedFormats = [BarcodeFormat.EAN_13, BarcodeFormat.CODE_128, BarcodeFormat.DATA_MATRIX /*, ...*/];

  close(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {

    this.orientationMediaQuery = window.matchMedia('(orientation: portrait)');

    this.applyOrientationStyle(this.orientationMediaQuery.matches);
    // Listener que dispara ao mudar orientação
    this.orientationListener = this.renderer.listen(this.orientationMediaQuery, 'change', (event: MediaQueryListEvent) => {
      this.applyOrientationStyle(event.matches);
    });
  }

  ngAfterViewInit() {
    if (this.scanner) {
      this.scanner.autostart = true; // Inicia o scanner automaticamente
    }
  }

  lockOrientation(orientation: 'portrait' | 'landscape') {
    const screenOrientation = (screen.orientation || (screen as any).mozOrientation || (screen as any).msOrientation);
    if (screenOrientation?.lock) {
      screenOrientation.lock(orientation).catch((err: any) => {
        console.warn('Não foi possível bloquear orientação:', err);
      });
    }
  }

  applyOrientationStyle(isPortrait: boolean) {
    const video = document.querySelector('video') as HTMLVideoElement;
    const modalContent = document.querySelector('.modal-content');

    if (!video || !modalContent) return;

    if (isPortrait) {
      video.style.setProperty("transform", "rotate(0deg)", "important");
      video.style.setProperty("height", "100dvh", "important");
      video.style.setProperty("width", "100dvw", "important");
      video.style.setProperty("object-fit", "cover", "important");

      modalContent.classList.remove('landscape-mask');
      modalContent.classList.add('portrait-mask');
      this.lockOrientation('portrait');
    } else {
      this.lockOrientation('landscape');
      video.style.setProperty("transform", "rotate(0deg)", "important");
      video.style.setProperty("width", "100dvw", "important");
      video.style.setProperty("height", "100dvh", "important");
      video.style.setProperty("object-fit", "cover", "important");

      modalContent.classList.remove('portrait-mask');
      modalContent.classList.add('landscape-mask');
    }

    const scanLine = document.querySelector('.scan-line');

    if (scanLine) {
      if (isPortrait) {
        scanLine.classList.add('portrait-scan-line');
      } else {
        scanLine.classList.remove('portrait-scan-line');
      }
    }

    const topChip = document.querySelector('.top-chip');

    if (topChip) {
      if (isPortrait) {
        topChip.classList.add('portrait-chip');
      } else {
        topChip.classList.remove('portrait-chip');
      }
    }
  }

  async onScanSuccess(result: string) {
    this.scanResult = result;
    let link = null
    this.functions.produto(result).pipe(
      // finalize(() => {
      //   //  this.fetchingData = false
      // })
    )
      .subscribe(
        {
          next: resp => {
            const { data } = resp.body;
            link = `/produto/${data.ean}/${data.nome.replace(/\s/g, '-').replace(/\//g, '')}.html`;
            this.close();
            this.router.navigate([link], { skipLocationChange: false, replaceUrl: true }).then(() => {
              window.location.reload();
            }).catch(console.error)
          },
          error: (error) => {
            const bottomChip = document.querySelector('.bottom-chip') as HTMLElement
            bottomChip.style.setProperty('display', '')
            bottomChip.innerText = 'Ocorreu um Erro ao Ler o códig de barras'
            console.error(error);
            link = null;
          }
        }
      );
  }

  onScanError(error: any) {
    console.error('Erro no scanner:', error);
  }

  onCamerasFound(cameras: MediaDeviceInfo[]) {
    console.log('Câmeras encontradas:', cameras);
  }

  onPermissionResponse(permission: boolean) {
    console.log('Permissão da câmera:', permission);
  }
}
